var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagPennant = function SvgFlagPennant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.714.844v.949l21.429 7.225c.482.158.857.632.857 1.107 0 .527-.321 1.002-.857 1.16L2.714 18.51v7.646c0 .475-.428.844-.857.844A.84.84 0 0 1 1 26.156V.844C1 .422 1.375 0 1.857 0c.429 0 .857.422.857.844m0 2.69V16.77l19.5-6.645z"
  })));
};
export default SvgFlagPennant;